import { SxProps, Theme } from '@mui/material';

export const SingleLoginFormEmailLabelSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-body)',
	lineHeight: '1',
};

export const SingleLoginFormEmailSX: SxProps<Theme> = (theme) => ({
	'.MuiOutlinedInput-notchedOutline': {
		border: '1px solid #C9C9C9',
		borderRadius: '6px',
	},
	'.MuiOutlinedInput-input': {
		padding: '14px 14px',
		fontSize: 'var(--font-size-body)',
		height: '20px',
	},
	marginTop: theme.spacing(0),
	marginBottom: theme.spacing(2),
});

export const SingleLoginFormPasswordLabelSX: SxProps<Theme> = { fontSize: 'var(--font-size-body)' };

export const SingleLoginFormPasswordSX: SxProps<Theme> = (theme) => ({
	'.MuiOutlinedInput-notchedOutline': {
		border: '1px solid #C9C9C9',
		borderRadius: '6px',
	},
	'.MuiOutlinedInput-input': {
		padding: '14px 14px',
		fontSize: 'var(--font-size-body)',
		height: '20px',
	},
	marginTop: '12px',
	marginBottom: theme.spacing(1),
});

export const SingleLoginFormForgotPasswordSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	color: '#929292',
	marginBottom: 1,
	fontWeight: '400',
	mt: '6px',
};

export const SingleLoginFormForgotPasswordLineSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	color: '#011688',
};

export const SingleLoginFormForgotPasswordBottomSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	marginTop: '20px',
};

export const SingleLoginFormCheckboxSX: SxProps<Theme> = {
	'&:hover': { bgcolor: 'transparent' },
};
